import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { PERMISSIONS } from "@/constants/permissions";
import { AgentPerformanceDashboard } from "@/pages/home/components/agent-performance-dashboard";
import { AgentPerformanceDashboardSearchSchema } from "@/pages/home/components/agent-performance-dashboard/agent-performance-dashboard-search.schema";
import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.PERFORMANCE_TEAM_PERFORMANCE)({
    component: AgentPerformanceDashboard,
    validateSearch: zodValidator(AgentPerformanceDashboardSearchSchema),
    staticData: {
        config: {
            breadcrumb: {
                title: "team_performance",
                to: APP_ROUTES_TO.PERFORMANCE_TEAM_PERFORMANCE,
            },
            title: "team_performance",
        },
        permissions: [PERMISSIONS.CALL_DASHBOARD_AGENT_PERFORMANCE],
    },
});
